import AudioManager from "../../Shared/AudioManager";
import Player from "../../Models/Player";
import Utils from "../../Shared/Utils";
import {Global} from "../../Shared/Global";
import TaskLayer from "../TaskLayer/TaskLayer";
import Activity from "./Activity";
import HallUI from "../HallUI";
import PopWindowManager from "../../Shared/PopWindowManager";
import TaskData from "../TaskLayer/TaskData";
import ActivityData from "./ActivityData";
import find = cc.find;
import EnterSoundManager from "../../Shared/EnterSoundManager";
import EventHandler = cc.Component.EventHandler;
import SignIn from "../Sign/SignIn";
import NoticeUI from "../NoticeUI";
import NetworkLogic from "../../Shared/NetworkLogic";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ActivityAndTask extends cc.Component {
    @property(cc.Node)
    shareRedPoint : cc.Node = null;
    @property(cc.Node)
    particleNode:cc.Node = null;
    // @property(cc.ParticleSystem)
    // pa2:cc.ParticleSystem = null;
    // @property(sp.Skeleton)
    // spine1 : sp.Skeleton = null;
    // @property(sp.Skeleton)
    // spine2 : sp.Skeleton = null;
    @property([cc.Prefab])
    pfbArr:cc.Prefab[] = [];
    @property(cc.Prefab)
    pfbShare:cc.Prefab = null;
    @property(cc.Prefab)
    pfbAgent:cc.Prefab = null;

    @property(cc.Prefab)
    TaskDetail:cc.Prefab = null;
    @property(cc.Node)
    contentNode : cc.Node = null;
    @property(cc.Label)
    labRedPointNum : cc.Label = null;
    @property(cc.ToggleContainer)
    toggleCont: cc.ToggleContainer = null;

    childLayerArr = {};

    private userData: any;

    private recommendTaskData = null;
    private recommendActivityData = null;
    tempParticle : cc.Node = null;

    onLoad(): void {
        // 隐藏大厅会导致，任务设置大厅的toggle后，不会发事件。所以不隐藏大厅
        // Utils.hideGameNode()
    }

    start() {
        cc.director.on(Global.UserEvent.UpdateShareRedPoint,this.updateShareRedPoint,this)
    }

    onDestroy(): void {
        cc.director.off(Global.UserEvent.UpdateShareRedPoint,this.updateShareRedPoint,this)
    }

    async updateShareRedPoint() {
        let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
        let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
        let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
        let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
        let date = new Date();
        let shareRedPoint = 0;
        if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
            !storageSave || storageSave != "save" + Player.getPy("userID") ||
            !storageShare || storageShare != "share" + Player.getPy("userID") ||
            !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
            ){
            shareRedPoint = 1;
        }
        NetworkLogic.taskGetTypes({},function (listType) {
            cc.log("===taskGetTypes:",listType);
            let redPointNum = 0;
            for (let i = 0;i < listType.length;i++){
                redPointNum += listType[i].finishCount
            }
            redPointNum += shareRedPoint;
            if (redPointNum > 0){
                this.shareRedPoint.active = true;
                this.shareRedPoint.getChildByName("redNum").getComponent(cc.Label).string = redPointNum;
            }else{
                this.shareRedPoint.active = false;

            }
        }.bind(this),function () {
            cc.log("===获取taskGetTypes类型错误:");
        })

    }

    updateUI(userData,recommendData?){
        cc.log("===进入updateUI");
        this.userData = userData;
        this.updateShareRedPoint();
        if (userData === "huodong"){
            // let pfb = this.getPfbByParam(userData);
            // pfb.active = true;
            this.recommendActivityData = recommendData;
            let toggle = this.toggleCont.toggleItems[0];
            let particle = cc.instantiate(this.particleNode);
            particle.parent = toggle.node;
            particle.position = cc.v2(0,0);
            this.tempParticle = particle;
            toggle.checkEvents[0].emit([toggle.checkEvents[0].customEventData]);
            EnterSoundManager.playSound("enter_huodong")
        }else if (userData === "renwu") {
            this.recommendTaskData = recommendData;
            let toggle = this.toggleCont.toggleItems[1];
            let particle = cc.instantiate(this.particleNode);
            particle.parent = toggle.node;
            particle.position = cc.v2(0,0);
            this.tempParticle = particle;
            toggle.check();
        }else if (userData === "notice"){
            let toggle = this.toggleCont.toggleItems[2];
            let particle = cc.instantiate(this.particleNode);
            particle.parent = toggle.node;
            particle.position = cc.v2(0,0);
            this.tempParticle = particle;
            toggle.check();
        }else if (userData === "signIn"){
            let toggle = this.toggleCont.toggleItems[3];

            toggle.check();
        }
    }

    async onToggleSelected(event, param, playSound = true) {
        cc.log("=====onToggleSelected 执行param：", param);
        playSound && AudioManager.playSound("toggle");
        this.tempParticle && this.tempParticle.destroy();

        for (let key in this.childLayerArr) {
            this.childLayerArr[key].active = false;
        }
        if (param === "huodong") {
            this._setParticle(this.toggleCont.toggleItems[0].node)
            let pfb = this.getPfbByParam(param);
            pfb.active = true;
            let activityLayer: Activity = pfb.getComponent("Activity");
            await activityLayer.updateActivityLayer(this.recommendActivityData);
            this.recommendActivityData = null;
        } else if (param === "renwu") {
            this._setParticle(this.toggleCont.toggleItems[1].node)
            let pfb = this.getPfbByParam(param);
            pfb.active = true;
            let taskLayer:TaskLayer  = pfb.getComponent("TaskLayer");
            await taskLayer.upateTaskLayer(this.recommendTaskData);
            this.recommendTaskData = null;
        }else if(param === "notice"){
            this._setParticle(this.toggleCont.toggleItems[2].node)
            let pfb = this.getPfbByParam("notice");
            pfb.active = true;
        }else if(param === "signIn"){
            this._setParticle(this.toggleCont.toggleItems[3].node);
            if(!Player.isLogedIn()){
                this.onBtnClose();
                let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.checkLoginAndShowUI();
                return;
            }
            let pfb = this.getPfbByParam("signIn");
            pfb.active = true;
            let signInLayer: SignIn = pfb.getComponent("SignIn");
            signInLayer.updateUI();
        }

    }

    _setParticle(node){
        let particle = cc.instantiate(this.particleNode);
        particle.parent = node;
        particle.active = true;
        particle.position = cc.v2(0,0);
        this.tempParticle = particle;
    }

    getPfbByParam(param){
        if (!this.childLayerArr[param.toString()]){
            let pfb  = cc.instantiate(this.pfbArr[this._getIndexByParam(param)]);
            pfb.parent = this.contentNode;
            pfb.position = cc.v2(0,0);
            this.childLayerArr[param.toString()] = pfb;
        }
        return this.childLayerArr[param.toString()]
    }

    _getIndexByParam(param){
        let index = 0;

        switch (param) {
            case "huodong":
                index =  0;
                break;
            case "renwu":
                index =  1;
                break;
            case "notice":
                index =  2;
                break;
            case "signIn":
                index =  3;
                break;
        }
        return index;

    }

    openChildUI (perfab: cc.Prefab) {
        let child = cc.instantiate(perfab);
        child.parent = this.node.parent;
        return child;
    }

    onBtnClose(){
        AudioManager.playSound("close");
        Utils.showGameNode();
        cc.log("==acAndTask重置任务数据");
        TaskData.resetData();
        ActivityData.resetData();
        PopWindowManager.openNext();
        this.node.destroy();
    }

}
